import { Navigate, Outlet, useLocation } from "react-router-dom";

import { ROUTES } from "@/constants/routes";
import { useAuthStore } from "@/store/auth";

/**
 * The signed-in gate. Replaces the `beforeLoad` redirect the file-based routes
 * carried: with a data router the check has to be an element, so it sits above
 * every layout that requires a session and hands the attempted URL to the sign-in
 * screen as `?redirect=`, exactly as the old `search: { redirect }` did.
 *
 * It *subscribes* to the token rather than reading a snapshot of it. A snapshot
 * is only re-read when something else re-renders this, which in practice meant
 * the next navigation: a session ended mid-page — an expired refresh token, an
 * account disabled, a session revoked from another device — left the person on
 * a signed-in-looking screen whose every request was failing, until they
 * happened to click through to another page. Subscribed, the store clearing is
 * itself the redirect.
 */
const PrivateRoute = () => {
  const location = useLocation();
  const accessToken = useAuthStore((state) => state.accessToken);
  if (!accessToken) {
    const back = `${location.pathname}${location.search}`;
    return <Navigate to={`${ROUTES.LOGIN}?redirect=${encodeURIComponent(back)}`} replace />;
  }
  return <Outlet />;
};

export default PrivateRoute;
